
// import Header from './Components/Header/Header';
// import Footer from './Components/Footer/Footer';
// import Home from './Pages/Home/Home';

// function App() {
//   return (
//     <div className="App">
     
// <Header/>
// <Home/>
// <Footer/>


//     </div>
//   );
// }

// export default App;
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Course from './Pages/Courses/Course';
import Contact from './Pages/Contact/Contact';
import Leadership from './Pages/Leaders/Leadership';
import Manufacturing from './Pages/Courses/Manufacturing';
import Design from './Pages/Courses/Design';
import Nurturing from './Pages/Nurturing/Nurturing'
import Osat from './Pages/Courses/Osat';
import Febosat from './Pages/Courses/Febosat';
import WhatsAppButton from './Components/WhatsAppButton/WhatsAppButton';
import ReachUsButton from './Components/ReachUsButton/ReachUsButton';
import Basic from './Pages/Basic/Basic';
import WaterFab from './Pages/WaterFab/WaterFab';
import Packaging from './Pages/Packaging/Packaging';
import Quality from './Pages/Quality/Quality';
import IndustrailConsuting from './Pages/IndustrailConsuting/IndustrailConsuting';
import TrutedAdvisory from './Pages/TrutedAdvisory/TrutedAdvisory';
import EnablingTawin from './Pages/EnablingTawin/EnablingTawin';
import EquipmentRefurbishment from './Pages/Equipment Refurbishment/Equipment Refurbishment';



function App() {
  return (
    <Router>
    
        <Header />
        <Routes> 
         <Route path="/" element={<Home/>}/>
         <Route path="/about" element={<About/>}/>
         <Route path="/courses" element={<Course/>}/>
         <Route path="/contact" element={<Contact/>}/>
         <Route path="/leadership" element={<Leadership/>}/>
         <Route path="/manufacturing" element={<Manufacturing/>}/>
         <Route path="/design" element={<Design/>}/>
         <Route path="/nurturing" element={<Nurturing/>}/>
         <Route path="/osat" element={<Osat/>}/>
         <Route path="/feb" element={<Febosat/>}/>

        <Route path="/basic" element={<Basic/>}/>
        <Route path="/waferfab" element={<WaterFab/>}/>
        <Route path="/packaging" element={<Packaging/>}/>
        <Route path="/quality" element={<Quality/>}/>
               <Route path="/service1" element={<TrutedAdvisory />} />
        <Route path="/service" element={<IndustrailConsuting />} />
        <Route path="/service2" element={<EnablingTawin />} />
 
        <Route path="/service3" element={<EquipmentRefurbishment />} />


        </Routes>
       
        <WhatsAppButton/>
        <Footer />
        <ReachUsButton/>
    </Router>
  );
}

export default App;
